import { render } from "./InviiComponent_archivio.vue?vue&type=template&id=be812e7a&scoped=true"
import script from "./InviiComponent_archivio.vue?vue&type=script&lang=js"
export * from "./InviiComponent_archivio.vue?vue&type=script&lang=js"

import "./InviiComponent_archivio.vue?vue&type=style&index=0&id=be812e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be812e7a"]])

export default __exports__